export default __webpack_public_path__ + "static/media/backers1.77ba4154.png";